import { render } from "./CitiesRelated.vue?vue&type=template&id=f841f3ec"
import script from "./CitiesRelated.vue?vue&type=script&lang=js"
export * from "./CitiesRelated.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__